import { AppButton, AppPrimaryButton } from "elements"
import { DotsThreeVertical } from "phosphor-react"
import { useState, useRef, useEffect } from "react"
import { Button, Modal } from "semantic-ui-react"
import styled from "styled-components"

const ActionDropdownContainer = styled.div`
    position: relative;
    display: inline-block;
`

const DropdownMenu = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #e8e9e9;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    min-width: 200px;
    z-index: 1000;
    margin-top: 8px;
    padding: 4px 0;
`

const MenuItem = styled.div`
    padding: 12px 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: background-color 0.2s ease;
    font-size: 14px;
    color: ${props => props.danger ? '#dc3545' : '#333'};

    &:hover {
        background-color: #f8f9fa;
    }
`

const ActionBoxes = ({ item, menuItems = [] }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [selectedAction, setSelectedAction] = useState(null)
    const dropdownRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const handleMenuClick = (menu) => {
        setDropdownOpen(false)

        if (menu.confirm) {
            setSelectedAction(menu)
            setConfirmOpen(true)
        } else {
            menu.onClick(item)
        }
    }

    const handleConfirm = () => {
        selectedAction?.onClick(item)
        setConfirmOpen(false)
        setSelectedAction(null)
    }

    return (
        <>
            <ActionDropdownContainer ref={dropdownRef}>
                <Button
                    icon
                    basic
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    style={{ padding: '8px', minWidth: 'auto' }}
                >
                    <DotsThreeVertical size={20} />
                </Button>

                {dropdownOpen && (
                    <DropdownMenu>
                        {menuItems.map((menu, index) => {
                            const Icon = menu.icon
                            return (
                                <MenuItem
                                    key={index}
                                    onClick={() => handleMenuClick(menu)}
                                    danger={menu.danger}
                                >
                                    {Icon && <Icon size={16} />}
                                    <span>{menu.label}</span>
                                </MenuItem>
                            )
                        })}
                    </DropdownMenu>
                )}
            </ActionDropdownContainer>

            <Modal
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                size="tiny"
            >
                <Modal.Header>
                    {selectedAction?.confirmTitle || "Confirm Action"}
                </Modal.Header>
                <Modal.Content>
                    <p>
                        {selectedAction?.confirmMessage || "Are you sure?"}
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <AppButton onClick={() => setConfirmOpen(false)}>
                        Cancel
                    </AppButton>
                    <AppPrimaryButton
                        onClick={handleConfirm}
                        style={{ backgroundColor: selectedAction?.danger ? '#dc3545' : undefined }}
                    >
                        Confirm
                    </AppPrimaryButton>
                </Modal.Actions>
            </Modal>
        </>
    )
}

export default ActionBoxes